import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Zap } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';

export const PlanBadge = ({ plan }) => {
  const { language } = useLanguage();
  const navigate = useNavigate();

  if (!plan || plan !== 'free') return null;

  return (
    <button
      onClick={() => navigate('/pricing')}
      className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-xs font-semibold transition-colors border border-amber-300 bg-amber-50 text-amber-800 hover:bg-amber-100"
      data-testid="plan-badge"
    >
      {language === 'es' ? 'Plan Gratuito' : 'Free Plan'}
      <Zap className="w-3 h-3" />
    </button>
  );
};

export const UsageCounter = ({ used, limit, label, onUpgrade }) => {
  const { language } = useLanguage();
  const pct = Math.min((used / limit) * 100, 100);
  const isAtLimit = used >= limit;

  return (
    <div className="flex items-center gap-3" data-testid="usage-counter">
      <div className="flex-1">
        <div className="flex items-center justify-between mb-1">
          <span className="text-xs font-medium text-gray-600">{label}</span>
          <span className={`text-xs font-bold ${isAtLimit ? 'text-red-600' : 'text-gray-700'}`}>
            {used} / {limit}
          </span>
        </div>
        <div className="w-full h-1.5 bg-gray-200 rounded-full overflow-hidden">
          <div
            className={`h-full rounded-full transition-all ${isAtLimit ? 'bg-red-500' : 'bg-purple-500'}`}
            style={{ width: `${pct}%` }}
          />
        </div>
      </div>
      {isAtLimit && onUpgrade && (
        <button
          onClick={onUpgrade}
          className="text-xs font-semibold whitespace-nowrap px-2 py-1 rounded-md hover:bg-purple-50"
          style={{ color: '#6949b6' }}
        >
          {language === 'es' ? 'Actualizar' : 'Upgrade'}
        </button>
      )}
    </div>
  );
};
